var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100mm",
    height: "100mm",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 52.761,
    cy: 44.105,
    r: 34.776,
    fill: "#26437e",
    stopColor: "#000000",
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.5417 -.85142)",
    stroke: "#f0f7ee",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(1.7641 .27721)",
    d: "m38.28 48.866c0 .55605-.45077 1.0068-1.0068 1.0068s-1.0068-.45077-1.0068-1.0068c0-.55605.45077-1.0068 1.0068-1.0068s1.0068.45077 1.0068 1.0068zm17.494 0c0 .55605.45077 1.0068 1.0068 1.0068s1.0068-.45077 1.0068-1.0068c0-.55605-.45077-1.0068-1.0068-1.0068s-1.0068.45077-1.0068 1.0068z",
    fill: "#f0f7ee"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(.76714 6.1003)",
    d: "m54.957 64.9c1.5243-1.51 2.1811-12.682 1.8376-14.312-.6331-3.0045-7.5222-3.1257-8.9797-3.1175-1.4575-.0082-8.3466.113-8.9797 3.1175-.34349 1.6301.31327 12.802 1.8376 14.312",
    fill: "#26437e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.31 74.097c-4.497 0-12.545-7.1551-14.675-11.526-1.0699-2.1952-1.5936-11.169-1.7084-17.07-.27207-13.99 7.1576-15.962 16.152-15.962m.77622 44.558c4.497 0 12.545-7.1551 14.675-11.526 1.0699-2.1952 1.5936-11.169 1.7084-17.07.27207-13.99-7.1576-15.962-16.152-15.962",
    fill: "none",
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m34.692 34.763s-3.8198-10.116-2.3617-14.982c1.0568-3.5267 8.7674-3.904 8.7674-3.904l.44461 20.195zm29.056 0s3.8198-10.116 2.3617-14.982c-1.0568-3.5267-8.7674-3.904-8.7674-3.904l-.44461 20.195z",
    fill: "#26437e"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2.1167)",
    d: "m49.22 28.89c-7.847.04021-10.941 4.5409-10.941 4.5409s-2.3754-2.0896-6.1623-1.1465c-6.7651 1.6847-5.0692 11.111-.05833 12.122 3.7347.51006 7.5617-.95492 7.5617-.95492 2.068 3.1277 5.755 4.5541 9.6001 4.538 3.8452.01611 7.5322-1.4103 9.6001-4.538 0 0 3.8271 1.465 7.5617.95492 5.0109-1.011 6.7068-10.437-.05833-12.122-3.7869-.94306-6.1623 1.1465-6.1623 1.1465s-3.0943-4.5007-10.941-4.5409z",
    fill: "#26437e"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(.52917)",
    d: "m45.01 58.722 3.0884 2.0489 3.0884-2.0489",
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.4da6f4117f31763054e64fd40dacb7eb.svg";
export { ForwardRef as ReactComponent };